import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Stack } from "@mui/material";
import { AppGlobalContext } from "contexts/GlobalContext";
import { useBoundStore } from "useStore";
import useAuth from "hooks/useAuth";
import useStateData from "../Queries/stateDataQuery";
import useTallerData from "../Queries/tallerDataQuery";
import Taller_Table from "./Taller_Table";
import Toolbar from "./Toolbar/Toolbar";
import DateFilterChip from "./Chip/DateFilterChip";
import StateFilterChip from "./Chip/StateFilterChip";
import SkeletonsAdminPage from "../Admin/SkeletonsAdminPage";
import "../servicesOperation.css";

const ESTADO_ID_BY_PERMISSION = {
  "ServiceOp:viewSAdmin": 2,
  default: 2,
};

const Taller = () => {
  const { mainCountry } = useContext(AppGlobalContext);
  const [country, setCountry] = React.useState(mainCountry);
  const navigate = useNavigate();
  const { user } = useAuth();

  const [dataTableHistory, setDataTableHistory] = useState([]);

  const isFirstRender = useRef(true);

  useEffect(() => {
    setCountry(mainCountry);
  }, [mainCountry]);

  const setSoTallerSearch = useBoundStore((state) => state.setSoTallerSearch);
  const setSoTallerPaginationModel = useBoundStore(
    (state) => state.setSoTallerPaginationModel,
  );
  const soTallerSelectedStatus = useBoundStore(
    (state) => state.soTallerSelectedStatus,
  );
  const setSoTallerSelectedStatus = useBoundStore(
    (state) => state.setSoTallerSelectedStatus,
  );

  const stateDataQuery = useStateData({ countryId: country.id });

  useEffect(() => {
    if (!stateDataQuery.data || soTallerSelectedStatus) return;

    const hasAdminPermission =
      user?.permissions?.includes("ServiceOp:viewSAdmin") || false;

    const defaultEstadoId = hasAdminPermission
      ? ESTADO_ID_BY_PERMISSION["ServiceOp:viewSAdmin"]
      : ESTADO_ID_BY_PERMISSION.default;

    const defaultStatus =
      stateDataQuery.data.find((s) => s.id === defaultEstadoId) ??
      stateDataQuery.data[0];

    setSoTallerSelectedStatus(defaultStatus);
  }, [stateDataQuery.data, soTallerSelectedStatus]);

  // Reset al cambiar de país
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setSoTallerSearch({ searchTerm: "", startDate: null, endDate: null });
    setSoTallerPaginationModel({ page: 0, pageSize: 50 });
    setSoTallerSelectedStatus(null);
    setDataTableHistory([]);
  }, [mainCountry]);

  const tallerDataQuery = useTallerData({ countryId: country.id });

  useEffect(() => {
    tallerDataQuery.refetch({ cancelRefetch: false });
  }, []);

  // Acumula historial para contar por estado
  useEffect(() => {
    if (!tallerDataQuery.data?.data) return;
    setDataTableHistory((prev) => {
      const toAdd = tallerDataQuery.data.data.filter(
        (d) => !prev.some((h) => h.id === d.id),
      );
      return [...prev, ...toAdd];
    });
  }, [tallerDataQuery.data]);

  const isInitialLoading =
    stateDataQuery.isLoading || tallerDataQuery.isLoading;
  const isFetching = tallerDataQuery.isFetching;

  const countPending = tallerDataQuery.data?.countIngreso;
  const countReparacion = tallerDataQuery.data?.countReparacion;

  const handleRowClick = (rowData) => {
    navigate(`/service-operation/services_operation/${rowData.id}`);
  };

  if (isInitialLoading) {
    return <SkeletonsAdminPage />;
  }

  return (
    <Stack direction="column" spacing={2}>
      <Toolbar
        isLoading={isFetching}
        countryId={country.id}
        countPending={countPending}
        countReparacion={countReparacion}
      />

      <Stack direction="row" flexWrap="wrap" gap={1}>
        <StateFilterChip />
        <DateFilterChip />
      </Stack>

      <Taller_Table country={country} onRowClick={handleRowClick} />
    </Stack>
  );
};

export default Taller;
